import React from "react";
import ReactDOM from "react-dom/client";
import * as Sentry from "@sentry/react";
import "./index.css";
import "./assets/css/style.css";
import "./assets/css/font-awesome-all.min.css";
import "swiper";
import AOS from "aos";
import "aos/dist/aos.css";
import "react-circular-progressbar/dist/styles.css";
import App from "./App";
import StoreContext from "./core/context/StoreContext";
import "./i18n";

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  tracesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

AOS.init();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Sentry.ErrorBoundary fallback={<p>An unexpected error occurred.</p>}>
    <StoreContext>
      <App />
    </StoreContext>
  </Sentry.ErrorBoundary>
);
